export const flowOptions = [
	{ value: 'inbound', label: 'inbound' },
	{ value: 'outbound', label: 'outbound' },
]
